import { TLanguages } from './const'

/*
 * Auswahllisten aus den Stammdaten (Branche, Angebotsart, …).
 *
 * Die Einträge kommen als `{ value_EN, value_DE }`. Welche der beiden Fassungen an
 * der Company gespeichert ist, hängt davon ab, in welcher Sprache sie angelegt
 * wurde — bei den Testfirmen steht dort der deutsche Text
 * ("Nahrungsmittel & Getränke"), die Auswahlfelder verglichen aber gegen
 * `value_EN`. Ohne Treffer zeigt react-select seinen Platzhalter, obwohl ein Wert
 * gespeichert ist: genau der Befund aus Anforderung #77.
 *
 * `optionsFor` erzeugt die Liste und hängt einen gespeicherten Wert, der zu keinem
 * Eintrag passt, als eigene Option an — so geht auch ein zwischenzeitlich aus den
 * Stammdaten entfernter Wert nicht still verloren.
 */
export const optionsFor = (values, language, storedValue) => {
	const isGerman = language !== TLanguages.EN
	const options = (values || []).map(item => ({
		value: item.value_EN,
		label: isGerman ? item.value_DE : item.value_EN
	}))

	if (!storedValue) return options
	if (options.some(option => option.value === storedValue)) return options

	// Deutscher Text gespeichert? Dann trägt der passende Eintrag ihn als Beschriftung.
	const byGerman = (values || []).find(item => item.value_DE === storedValue)
	if (byGerman) return options

	return [...options, { value: storedValue, label: storedValue }]
}

/*
 * Beschriftung eines gespeicherten Werts in der gewählten Sprache — für
 * Ansichten, die den Wert nur anzeigen und kein Auswahlfeld brauchen.
 *
 * Trifft der Wert keinen Eintrag der Liste, steht er unverändert da: besser der
 * rohe Text als ein leeres Feld.
 */
export const optionLabel = (values, storedValue, language) => {
	if (!storedValue) return ''

	const match = (values || []).find(item => item.value_EN === storedValue || item.value_DE === storedValue)
	if (!match) return storedValue

	return language === TLanguages.EN ? match.value_EN : match.value_DE
}

/*
 * Übersetzt einen gespeicherten Wert in den Schlüssel, unter dem er in der Liste
 * steht (`value_EN`). Passt er zu keinem Eintrag, bleibt er unverändert — dann
 * trägt ihn die von `optionsFor` angehängte Option.
 */
export const canonicalOptionValue = (values, storedValue) => {
	if (!storedValue) return storedValue

	const match = (values || []).find(item => item.value_EN === storedValue || item.value_DE === storedValue)

	return match ? match.value_EN : storedValue
}
